import React from "react";
import { useCalculatorModal } from "../../context/calculator-modal-context";

const calculators = [
  {
    id: 1,
    title: "Personal Loan",
    subTitle: "EMI Calculator",
    color: "#8b5cf6",
    icon: (
      <svg
        className="h-6 w-6 text-white"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M12 2a5 5 0 0 1 5 5v1a5 5 0 0 1-10 0V7a5 5 0 0 1 5-5z" />
        <path d="M20 21a8 8 0 1 0-16 0" />
      </svg>
    ),
  },
  {
    id: 2,
    title: "Business Loan",
    subTitle: "EMI Calculator",
    color: "#10b981",
    icon: (
      <svg
        className="h-6 w-6 text-white"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <rect x="2" y="7" width="20" height="14" rx="2" ry="2" />
        <path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16" />
      </svg>
    ),
  },
  {
    id: 3,
    title: "Loan Eligibility",
    subTitle: "Calculator",
    color: "#f97316",
    icon: (
      <svg
        className="h-6 w-6 text-white"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M9 11l3 3L22 4" />
        <path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11" />
      </svg>
    ),
  },
  {
    id: 4,
    title: "Gold Loan",
    subTitle: "Calculator",
    color: "#f59e0b",
    icon: (
      <svg
        className="h-6 w-6 text-white"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <circle cx="8" cy="8" r="6" />
        <path d="M18.09 10.37A6 6 0 1 1 10.34 18" />
        <path d="M7 6h1v4" />
      </svg>
    ),
  },
  {
    id: 5,
    title: "EV Loan",
    subTitle: "EMI Calculator",
    color: "#06b6d4",
    icon: (
      <svg
        className="h-6 w-6 text-white"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M19 17h2c.6 0 1-.4 1-1v-3c0-.9-.7-1.7-1.5-1.9C18.7 10.6 16 10 16 10s-1.3-1.4-2.2-2.3c-.5-.4-1.1-.7-1.8-.7H5c-.6 0-1.1.4-1.4.9l-1.5 2.8C2.1 10.7 2 10.9 2 11.1V16c0 .6.4 1 1 1h2" />
        <circle cx="7" cy="17" r="2" />
        <path d="M9 17h6" />
        <circle cx="17" cy="17" r="2" />
        <path d="M13 3l-2 4h3l-2 4" />
      </svg>
    ),
  },
  {
    id: 6,
    title: "Stamp Duty",
    subTitle: "Calculator",
    color: "#a855f7",
    icon: (
      <svg
        className="h-6 w-6 text-white"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
        <polyline points="14 2 14 8 20 8" />
        <line x1="16" y1="13" x2="8" y2="13" />
        <line x1="16" y1="17" x2="8" y2="17" />
        <polyline points="10 9 9 9 8 9" />
      </svg>
    ),
  },
  {
    id: 7,
    title: "ROI",
    subTitle: "Calculator",
    color: "#3b82f6",
    icon: (
      <svg
        className="h-6 w-6 text-white"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <line x1="18" y1="20" x2="18" y2="10" />
        <line x1="12" y1="20" x2="12" y2="4" />
        <line x1="6" y1="20" x2="6" y2="14" />
      </svg>
    ),
  },
];

function FinancialCalculators() {
  const { openCalculatorModal } = useCalculatorModal();

  return (
    <section id="financial-calculators" className="relative overflow-hidden bg-gradient-to-b from-[#063b28] via-[#053625] to-[#042e1f] py-14 sm:py-16 lg:py-20 scroll-mt-20">
      {/* Soft Ambient Radial Lights */}
      <div
        aria-hidden="true"
        className="pointer-events-none absolute -left-20 top-0 h-[450px] w-[450px] rounded-full bg-[radial-gradient(circle,rgba(46,229,162,0.12),transparent_65%)] blur-2xl"
      />
      <div
        aria-hidden="true"
        className="pointer-events-none absolute -right-20 bottom-0 h-[450px] w-[450px] rounded-full bg-[radial-gradient(circle,rgba(242,211,94,0.08),transparent_65%)] blur-2xl"
      />

      <div className="section-container relative z-10">
        
        {/* ================= SECTION HEADER ================= */}
        <div className="text-center max-w-[700px] mx-auto">
          <p className="font-jakarta text-[11px] font-medium tracking-[0.34em] text-[var(--mint-green)] sm:text-[12px] uppercase mb-2.5">
            SMART TOOLS
          </p>
          <h2 className="font-bricolage text-[30px] sm:text-[36px] md:text-[40px] font-bold leading-[1.1] tracking-[-1.2px] text-white">
            Financial{" "}
            <span className="text-[var(--mint-green)]">Calculators</span>
          </h2>
          <p className="mt-3 font-jakarta text-[14px] sm:text-[16px] leading-[1.6] text-[#a9c9be]">
            Plan your finances better with our easy calculators
          </p>
        </div>

        {/* ================= 7 CALCULATOR CARDS GRID ================= */}
        <div className="mt-10 sm:mt-12 grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-7 gap-3.5 sm:gap-4 lg:gap-3.5 xl:gap-4">
          {calculators.map((calc) => (
            <div
              key={calc.id}
              onClick={() => openCalculatorModal(`${calc.title} ${calc.subTitle}`)}
              className="group relative flex flex-col items-center justify-center rounded-[20px] sm:rounded-[22px] bg-white p-4 sm:p-5 shadow-[0_10px_25px_rgba(0,0,0,0.12)] border border-white/20 transition-all duration-300 hover:-translate-y-1.5 hover:shadow-[0_16px_35px_rgba(46,229,162,0.22)] cursor-pointer min-h-[145px] sm:min-h-[155px]"
            >
              {/* Top Circular Colored Icon Badge */}
              <div
                className="flex h-12 w-12 sm:h-14 sm:w-14 shrink-0 aspect-square items-center justify-center rounded-full shadow-sm transition-transform duration-300 group-hover:scale-110"
                style={{ backgroundColor: calc.color }}
              >
                {calc.icon}
              </div>

              {/* Title & Subtitle */}
              <div className="mt-3 text-center">
                <p className="font-bricolage text-[13px] sm:text-[14px] font-bold leading-[1.25] tracking-[-0.2px] text-[#111827]">
                  {calc.title}
                </p>
                <p className="font-bricolage text-[12px] sm:text-[13px] font-semibold leading-[1.25] text-[#4b5563] group-hover:text-[var(--hero-green)] transition-colors">
                  {calc.subTitle}
                </p>
              </div>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
}

export default FinancialCalculators;
